module.exports = __webpack_public_path__ + "static/media/1134.47616c69.jpg";